document.addEventListener('DOMContentLoaded', function () {
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeReviews(payload) {
    if (Array.isArray(payload)) return payload;
    if (payload && Array.isArray(payload.reviews)) return payload.reviews;
    if (payload && Array.isArray(payload.data)) return payload.data;
    return [];
  }

  function renderReviewItem(review) {
    var name = escapeHtml(review.name || review.author || 'Anonymous');
    var date = escapeHtml(review.date || review.created_at || '');
    var message = escapeHtml(review.message || review.content || review.review || '');
    var rating = parseInt(review.rating || '0', 10);
    var ratingMarkup = rating
      ? '<div class="kiddy-review-rating" aria-label="' + rating + ' star rating">' + '★'.repeat(Math.max(1, Math.min(5, rating))) + '</div>'
      : '';
    var avatarMarkup = '<div class="kiddy-review-avatar-fallback">' + name.charAt(0) + '</div>';

    return '' +
      '<li class="comment">' +
        '<article>' +
          '<div class="comment_image">' + avatarMarkup + '</div>' +
          '<div class="comment_text">' +
            '<h6 class="title">' + name + '</h6>' +
            '<div class="comment_date">' + date + '</div>' +
            ratingMarkup +
            '<p>' + message + '</p>' +
          '</div>' +
        '</article>' +
      '</li>';
  }

  function buildReviewUrl(baseUrl, wrapper) {
    var url = new URL(baseUrl, window.location.origin);
    url.searchParams.set('product_key', wrapper.dataset.productKey || '');
    url.searchParams.set('product_handle', wrapper.dataset.productHandle || '');
    url.searchParams.set('product_id', wrapper.dataset.productId || '');
    url.searchParams.set('market', wrapper.dataset.reviewMarket || '');
    url.searchParams.set('locale', wrapper.dataset.reviewLocale || '');
    url.searchParams.set('display_mode', wrapper.dataset.reviewDisplayMode || 'same_product_same_market');
    return url.toString();
  }

  function initReviewFeed(wrapper) {
    var feedUrl = wrapper.dataset.reviewFeed;
    var list = wrapper.querySelector('[data-review-list]');
    var count = wrapper.querySelector('[data-review-count]');
    var tab = document.querySelector('[data-bs-target="#' + (wrapper.closest('.tab-pane') || {}).id + '"]');
    var tabCount = tab ? tab.querySelector('[data-review-tab-count]') : null;
    var scrollArea = wrapper.querySelector('[data-review-scroll-area]');
    var pagination = wrapper.querySelector('[data-review-pagination]');
    var pageSize = parseInt(wrapper.dataset.visibleReviews || '3', 10);
    var currentPage = 1;
    var activeReviews = [];
    if (!list || !scrollArea) return;

    function syncCount(total) {
      if (count) count.textContent = '[' + total + ']';
      if (tabCount) tabCount.textContent = '(' + total + ')';
    }

    function renderPagination(totalPages) {
      if (!pagination) return;
      if (totalPages <= 1) {
        pagination.hidden = true;
        pagination.innerHTML = '';
        return;
      }

      var markup = '<button type="button" class="kiddy-review-page-btn" data-review-page-action="prev"' + (currentPage === 1 ? ' disabled' : '') + '>Prev</button>';
      for (var i = 1; i <= totalPages; i += 1) {
        markup += '<button type="button" class="kiddy-review-page-btn' + (i === currentPage ? ' is-active' : '') + '" data-review-page="' + i + '">' + i + '</button>';
      }
      markup += '<button type="button" class="kiddy-review-page-btn" data-review-page-action="next"' + (currentPage === totalPages ? ' disabled' : '') + '>Next</button>';
      pagination.innerHTML = markup;
      pagination.hidden = false;
    }

    function renderReviewPage(reviews) {
      var total = reviews.length;
      var totalPages = Math.max(1, Math.ceil(total / pageSize));
      currentPage = Math.min(Math.max(1, currentPage), totalPages);
      var start = (currentPage - 1) * pageSize;
      var pageReviews = reviews.slice(start, start + pageSize);

      list.innerHTML = pageReviews.map(renderReviewItem).join('');
      syncCount(total);
      renderPagination(totalPages);
      scrollArea.style.maxHeight = '';
      scrollArea.classList.remove('is-scrollable');
    }

    if (!feedUrl) {
      syncCount(list.querySelectorAll(':scope > .comment').length);
      if (pagination) pagination.hidden = true;
      return;
    }

    list.innerHTML = '';
    syncCount(0);
    if (pagination) pagination.hidden = true;

    if (pagination) {
      pagination.addEventListener('click', function (event) {
        var button = event.target.closest('button');
        if (!button || button.disabled) return;

        var totalPages = Math.max(1, Math.ceil(activeReviews.length / pageSize));
        if (button.dataset.reviewPageAction === 'prev') currentPage -= 1;
        if (button.dataset.reviewPageAction === 'next') currentPage += 1;
        if (button.dataset.reviewPage) currentPage = parseInt(button.dataset.reviewPage, 10);
        currentPage = Math.min(Math.max(1, currentPage), totalPages);
        renderReviewPage(activeReviews);
      });
    }

    fetch(buildReviewUrl(feedUrl, wrapper), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load reviews');
        return response.json();
      })
      .then(function (payload) {
        var reviews = normalizeReviews(payload).filter(function (item) {
          if (!item) return false;
          var itemProductKey = item.product_key || item.productKey || '';
          var itemMarket = String(item.market || '').trim();
          var currentMarket = String(wrapper.dataset.reviewMarket || '').trim();
          if (itemProductKey && String(itemProductKey) !== String(wrapper.dataset.productKey || '')) return false;
          if (currentMarket && itemMarket !== currentMarket) return false;
          if (!itemProductKey && !item.product_handle && !item.productHandle && !item.product_id && !item.productId) return true;
          return String(item.product_handle || item.productHandle || '') === String(wrapper.dataset.productHandle || '') ||
            String(item.product_id || item.productId || '') === String(wrapper.dataset.productId || '');
        });

        if (!reviews.length) {
          syncCount(0);
          list.innerHTML = '';
          if (pagination) pagination.hidden = true;
          return;
        }

        activeReviews = reviews;
        currentPage = 1;
        renderReviewPage(activeReviews);
      })
      .catch(function () {
        activeReviews = [];
        list.innerHTML = '';
        syncCount(0);
        if (pagination) pagination.hidden = true;
      });
  }

  function initReviewForm(form) {
    var submitUrl = form.dataset.reviewSubmit;
    var message = form.querySelector('[data-review-form-message]');
    if (!submitUrl) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var formData = new FormData(form);
      formData.append('product_handle', form.dataset.productHandle || '');
      formData.append('product_id', form.dataset.productId || '');
      formData.append('product_key', form.dataset.productKey || form.dataset.productHandle || '');
      formData.append('market', form.dataset.reviewMarket || '');
      formData.append('store_domain', form.dataset.storeDomain || window.location.host);
      formData.append('locale', form.dataset.reviewLocale || document.documentElement.lang || '');
      formData.append('source_url', window.location.href);

      var button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;
      if (message) {
        message.hidden = false;
        message.textContent = 'Submitting...';
      }

      fetch(submitUrl, {
        method: 'POST',
        body: formData
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Submit failed');
          form.reset();
          if (message) message.textContent = 'Review submitted successfully.';
        })
        .catch(function () {
          if (message) message.textContent = 'Submit failed. Please check the Google Sheets endpoint.';
        })
        .finally(function () {
          if (button) button.disabled = false;
        });
    });
  }

  document.querySelectorAll('[data-qty-target]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input');
    if (!input) return;
    wrapper.querySelectorAll('button[data-qty-action]').forEach(function (button) {
      button.addEventListener('click', function () {
        var current = parseInt(input.value || '1', 10);
        if (button.dataset.qtyAction === 'plus') input.value = current + 1;
        if (button.dataset.qtyAction === 'minus') input.value = Math.max(1, current - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form && form.dataset.autoSubmit === 'true') form.submit();
    });
  });

  function openEcomSendPopup() {
    var launcherSelectors = [
      '[class*="_myCustomWidget_"]',
      '[class*="_widgetText_"]',
      '[data-ecomsend-widget]',
      '[data-sendwill-widget]'
    ];
    var launcher = null;

    for (var i = 0; i < launcherSelectors.length; i += 1) {
      launcher = document.querySelector(launcherSelectors[i]);
      if (launcher) break;
    }

    if (launcher) {
      launcher.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      }));
      return true;
    }

    if (window.EcomSendApps) {
      document.dispatchEvent(new CustomEvent('ecomsend:open'));
      window.dispatchEvent(new CustomEvent('ecomsend:open'));
    }

    return false;
  }

  document.querySelectorAll('[data-ecomsend-popup-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();

      if (openEcomSendPopup()) {
        return;
      }

      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;
        if (openEcomSendPopup() || attempts >= 20) {
          window.clearInterval(timer);
        }
      }, 250);
    });
  });

  document.querySelectorAll('[data-review-scroll-area]').forEach(function (area) {
    var wrapper = area.closest('.kiddy-reviews');
    if (wrapper) initReviewFeed(wrapper);
  });

  document.querySelectorAll('[data-review-form]').forEach(function (form) {
    initReviewForm(form);
  });
});
